"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Literal = exports.Null = exports.Path = exports.Identifier = exports.Function = void 0;
class Function {
    constructor(name, params) {
        this.name = name;
        this.params = params;
        this.name = name;
        this.params = params;
    }
    accept(visitor) {
        return visitor.visitFunction(this);
    }
    revert() {
        return this.name;
    }
}
exports.Function = Function;
class Identifier {
    constructor(identifier) {
        this.identifier = identifier;
        this.identifier = identifier;
    }
    accept(visitor) {
        return visitor.visitIdentifier(this);
    }
    revert() {
        return this.identifier;
    }
}
exports.Identifier = Identifier;
class Path {
    constructor(object, property) {
        this.object = object;
        this.property = property;
        this.object = object;
        this.property = property;
    }
    accept(visitor) {
        return visitor.visitPath(this);
    }
    revert() {
        return this.object;
    }
}
exports.Path = Path;
class Null {
    constructor(token) {
        this.token = token;
        this.token = token;
    }
    accept(visitor) {
        return visitor.visitNull(this);
    }
    revert() {
        return this.token;
    }
}
exports.Null = Null;
class Literal {
    constructor(value, token) {
        this.value = value;
        this.token = token;
        this.value = value;
        this.token = token;
    }
    accept(visitor) {
        return visitor.visitLiteral(this);
    }
    revert() {
        return this.token;
    }
}
exports.Literal = Literal;
//# sourceMappingURL=expression.js.map